export type CursorAgentPendingRun = {
  agentId: string;
  runId?: string;
};

const PENDING_KEY = 'cursorAgent.pendingRun';

export function loadPendingAgentRun(): CursorAgentPendingRun | null {
  try {
    const raw = localStorage.getItem(PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CursorAgentPendingRun;
    if (!parsed?.agentId || typeof parsed.agentId !== 'string') return null;
    const out: CursorAgentPendingRun = { agentId: parsed.agentId.trim() };
    if (typeof parsed.runId === 'string' && parsed.runId.trim()) {
      out.runId = parsed.runId.trim();
    }
    return out.agentId ? out : null;
  } catch {
    return null;
  }
}

export function savePendingAgentRun(pending: CursorAgentPendingRun | null): void {
  try {
    if (!pending?.agentId?.trim()) {
      localStorage.removeItem(PENDING_KEY);
      return;
    }
    const payload: CursorAgentPendingRun = { agentId: pending.agentId.trim() };
    if (pending.runId?.trim()) payload.runId = pending.runId.trim();
    localStorage.setItem(PENDING_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
}

export function clearPendingAgentRun(): void {
  savePendingAgentRun(null);
}
